import React from 'react';
import { BUSINESS } from '../config';

export default function Confidentialite() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16" data-testid="confidentialite-page">
      <h1 className="font-heading font-heading text-3xl uppercase tracking-tight text-primary mb-8">Politique de confidentialité</h1>
      
      <div className="prose prose-slate max-w-none space-y-8 text-slate-700 text-sm leading-relaxed">
        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Responsable du traitement</h2>
          <p>
            <strong className="text-primary">{BUSINESS.name}</strong><br />
            {BUSINESS.adresse}<br />
            Téléphone : {BUSINESS.telephone}
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Données collectées</h2>
          <p>
            Lors d'une réservation de produit, nous collectons uniquement :
          </p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>Nom et Prénom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Finalité du traitement</h2>
          <p>
            Ces données sont utilisées exclusivement pour la gestion de votre réservation (confirmation, contact en cas de besoin, suivi du retrait).
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Durée de conservation</h2>
          <p>
            Les données liées aux réservations sont automatiquement supprimées ou anonymisées au bout de <strong className="text-primary">30 jours</strong> après la date de réservation.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Vos droits</h2>
          <p>
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. Vous pouvez exercer ces droits en nous contactant par téléphone au <strong className="text-secondary">{BUSINESS.telephone}</strong> ou en vous rendant directement en boutique.
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Cookies</h2>
          <p>
            Ce site n'utilise pas de cookies de suivi ou publicitaires. Seuls des cookies techniques essentiels au fonctionnement du site peuvent être utilisés.
          </p>
          <p className="mt-2">
            Fait exception un cookie fonctionnel, mi_journey, déposé uniquement au moment où vous cliquez sur un bouton de prise de rendez-vous : il permet de joindre à votre demande la liste des fiches produits récemment consultées afin de préparer votre rappel téléphonique (durée de vie : 1 heure, supprimé après l'envoi de votre demande — voir la section « Préparation des rendez-vous »).
          </p>
        </section>

        <section>
          <h2 className="font-heading font-heading text-xl uppercase tracking-wider text-primary mb-3">Préparation des rendez-vous</h2>
          <p>
            Lorsque vous réservez un rappel téléphonique depuis notre boutique, la liste
            des fiches produits que vous avez récemment consultées peut être jointe à votre
            demande afin de préparer l'appel. Ces informations sont conservées avec votre
            demande de rendez-vous et ne sont jamais partagées avec des tiers.
          </p>
        </section>
      </div>
    </div>
  );
}
